import './OldMainSideBar.scss'

import Menu, { MenuItem } from '../../components/Menu/Menu'
import React, { Fragment } from 'react'

import t from '../../helpers/i18n'
import { useSelector } from 'react-redux'

const OldMainSideBar = () => {
  const products = useSelector(state => state.profile && state.profile.products)

  return (
    <div className="main-side-bar">
      {products && products.OLD_DELEGATE &&
        <Menu colorfull>
          <MenuItem title={t('menu.Introduction')} icon="DashboardIcon" link="/cm/delegate" />
        </Menu>
      }
      <Menu colorfull title={t('menu_titles.Administration')}>
        {products && products.OLD_CM &&
          <Fragment>
            <MenuItem title={t('menu.Categories')} icon="CompetitionsIcon" link="/cm/categories" />
          </Fragment>
        }
        <MenuItem title={t('menu.Teams')} icon="TeamsIcon" link="/cm/teams" />
        {products && products.OLD_CM &&
          <MenuItem title={t('menu.Responsible_Registration')} icon="DelegatesIcon" link="/cm/delegates" />
        }
      </Menu>
    </div>
  )
}

export default OldMainSideBar